import { render, staticRenderFns } from "./FlatGallery.vue?vue&type=template&id=4d08bc80&scoped=true&"
import script from "./FlatGallery.vue?vue&type=script&lang=js&"
export * from "./FlatGallery.vue?vue&type=script&lang=js&"
import style0 from "./FlatGallery.vue?vue&type=style&index=0&id=4d08bc80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d08bc80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d08bc80')) {
      api.createRecord('4d08bc80', component.options)
    } else {
      api.reload('4d08bc80', component.options)
    }
    module.hot.accept("./FlatGallery.vue?vue&type=template&id=4d08bc80&scoped=true&", function () {
      api.rerender('4d08bc80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/blocks/FlatGallery.vue"
export default component.exports